module.exports = __webpack_public_path__ + "img/Zrzutekranu2020-05-3o00.46.53.2ccb9dfd.jpg";